type DefaultFileFieldItemProps = { fileName: string };

const DefaultFileFieldItem = ({ fileName }: DefaultFileFieldItemProps) => {
    return <span>{fileName}</span>;
};

export { DefaultFileFieldItem };
